(() => {
  angular
    .module('gm.common.directives')
    .directive('gmyCaptcha', gmyCaptcha);

  function gmyCaptcha(
    $timeout,
    $window,
    Config
  ) {
    'ngInject';

    let _createdReCaptchaScript = false;
    let _initedReCaptcha = false;

    return {
      link,
      replace: true,
      require: 'ngModel',
      restrict: 'E',
      template: '<div></div>',
    };

    function link(scope, element, _attrs, ctrl) {
      let initTimer;

      function createReCaptchaScript() {
        if (!_createdReCaptchaScript) {
          const el = $window.$(
            `
            <script src="https://www.google.com/recaptcha/api.js?onload=initReCaptcha&render=explicit" async defer></script>
            `
          );

          $window.$('head').append(el);

          _createdReCaptchaScript = true;
        }
      }

      function initReCaptchaCb(cb) {
        if (_initedReCaptcha) {
          initTimer = $timeout(cb.bind(null, $window.grecaptcha));
        } else {
          $window.initReCaptcha = function _initReCaptcha() {
            _initedReCaptcha = true;
            cb($window.grecaptcha);
          };
        }
      }

      function onCaptchaReset() {
        ctrl.$setViewValue(null);
        $window.grecaptcha.reset();
      }

      function onDestroy() {
        $timeout.cancel(initTimer);
      }

      scope.$on('gm:captcha:reset', onCaptchaReset);
      scope.$on('$destroy', onDestroy);

      createReCaptchaScript();

      initReCaptchaCb((grecaptcha) => {
        grecaptcha.render(element[0], {
          sitekey: Config.recaptcha.sitekey,
          callback: (resp) => {
            ctrl.$setViewValue(resp);
          },
          'expired-callback': () => {
            ctrl.$setViewValue(null);
          }
        });
      });
    }
  }
})();
